import React, { useRef, useState } from 'react';

// Event picture picker: one big tap target on phones (opens the photo library
// or camera), drag-and-drop on computers, then a preview with Change/Remove.
export default function BannerPicker({ banner, uploading, error, onFile, onRemove }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const choose = () => inputRef.current && inputRef.current.click();

  const onInputChange = (event) => {
    const file = event.target.files && event.target.files[0];
    // Reset so choosing the same file again still triggers a change.
    event.target.value = '';
    if (file) onFile(file);
  };

  const dropHandlers = {
    onDragOver: (event) => {
      event.preventDefault();
      setDragging(true);
    },
    onDragLeave: () => setDragging(false),
    onDrop: (event) => {
      event.preventDefault();
      setDragging(false);
      const file = event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) onFile(file);
    },
  };

  return (
    <div className="banner-picker">
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={onInputChange}
        className="banner-picker-input"
        aria-label="Choose a picture for the event"
        tabIndex={-1}
      />

      {banner ? (
        <div className="banner-picker-preview" {...dropHandlers}>
          <img src={banner} alt="Event banner preview" />
          {uploading && <div className="banner-picker-busy">Uploading…</div>}
          <div className="banner-picker-actions">
            <button type="button" onClick={choose} disabled={uploading}>Change</button>
            <button type="button" onClick={onRemove} disabled={uploading}>Remove</button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          className={`banner-picker-drop${dragging ? ' is-dragging' : ''}`}
          onClick={choose}
          disabled={uploading}
          {...dropHandlers}
        >
          {uploading ? (
            <strong>Uploading…</strong>
          ) : (
            <>
              <strong>Add a picture (optional)</strong>
              <span>Tap to choose a photo or take one</span>
              <span className="banner-picker-desktop">or drag one here</span>
            </>
          )}
        </button>
      )}

      {error && <div className="banner-picker-error" role="alert">{error}</div>}
    </div>
  );
}
